<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PmQ1nr/tc-custom/9781442497597.jpg?1730490459094" alt="This image is the cover for the book Redeemed, The Missing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Redeemed, The Missing
      </h1>
      <p class="bookDescription body article font2">
        <b>Jonah’s new twin must time travel and face off against his siblings’ worst enemy in order to save the future—and his family—in the eighth and final book of the <i>New York Times</i> bestselling The Missing series, which <i>Kirkus Reviews </i>calls “plenty of fun and great for history teachers as well.”</b><br/><br/>After traveling through history multiple times and finding out his original identity, Jonah thought he’d fixed everything. But some of his actions left unexpected consequences. His parents—and many other adults—are still stuck as teenagers. And now Jonah has a new sibling, an identical twin brother named Jordan.<br/><br/>As odd as all this is for Jonah, it’s beyond confusing for Jordan. How does everyone in his family have memories of Jonah when he doesn’t? How can his annoying kid sister Katherine speak so expertly about time travel—and have people from the future treating her with respect? A few rash moves by Jordan send them all into the future—and into danger. What if he’s also the only one who can get them back to safety, once and for all?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margaret Peterson Haddix
      </h2>
      
      <p class="authorDescription body article">Margaret Peterson Haddix is the author of many critically and popularly acclaimed YA and middle grade novels, including the Children of Exile series, The Missing series, the Under Their Skin series, and the Shadow Children series. A graduate of Miami University (of Ohio), she worked for several years as a reporter for&#160;<I>The Indianapolis News</I>. She also taught at the Danville (Illinois) Area Community College. She lives with her family in Columbus, Ohio. Visit her at HaddixBooks.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      S&S Books for Young Readers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ab57466